"use strict";

const MAINTENANCE_PATH = "/system-maintenance";
const STORAGE_KEY = "systemMaintenancePayload";

const isSuperAdminSession = () => {
  if (typeof window === "undefined") {
    return false;
  }
  if (window.location.pathname.startsWith("/superadmin")) {
    return true;
  }
  return localStorage.getItem("accountScope") === "super_admin";
};

const parseRetryAfterSeconds = response => {
  const header = response?.headers?.["retry-after"];
  const parsed = Number(header);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 300;
};

const isMaintenanceResponse = (errorOrData, response) => {
  const status = response?.status ?? errorOrData?.response?.status;
  const data =
    (errorOrData && typeof errorOrData === "object" && errorOrData.maintenance !== undefined
      ? errorOrData
      : null) ||
    errorOrData?.response?.data ||
    null;

  return status === 503 && data?.maintenance === true;
};

const redirectToMaintenance = (error, response) => {
  if (typeof window === "undefined" || isSuperAdminSession()) {
    return false;
  }

  if (window.location.pathname === MAINTENANCE_PATH) {
    return true;
  }

  const data = error?.response?.data || error || {};
  const payload = {
    message: data.msg || data.message || "System is under maintenance. Please try again later.",
    retryAfterSeconds: parseRetryAfterSeconds(error?.response || response),
    at: Date.now(),
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  window.location.href = MAINTENANCE_PATH;
  return true;
};

const getStoredMaintenancePayload = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_err) {
    return null;
  }
};

const clearMaintenancePayload = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};

module.exports = {
  MAINTENANCE_PATH,
  STORAGE_KEY,
  isSuperAdminSession,
  isMaintenanceResponse,
  redirectToMaintenance,
  getStoredMaintenancePayload,
  clearMaintenancePayload,
};
